import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 39AEA4FF-B65C-4368-B582-98108E3F9F06
 * name arrow-right-drop-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right-drop-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowRightDropCircleIcon = createSvgIcon(<><path d="M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M10,17L15,12L10,7V17Z" /></>, 'ArrowRightDropCircleIcon');
export default ArrowRightDropCircleIcon